<template>
  <div class="DataTables RequestDetailsComponent ">

    <p>{{lang.infotext_1}}:</p>
    <LoaderComponent v-if="!isData"></LoaderComponent>

    
      <div :id="id"></div>
      
      <p v-show="isEdit">{{lang.infotext_2}}:</p>

      <b-form-file v-show="isEdit" class="library-files" v-model="requestFiles" :placeholder="lang.filesPlaceholder"
        drop-placeholder="Drop file here..." multiple></b-form-file>
      <br><br>
      
  </div>
</template>
<script>

  import LoaderComponent from "@/components/shared/LoaderComponent"
  
  import * as Tools from '@/Tools/Tools'
  import { mapGetters } from 'vuex'



  export default {
    name: "RequestDetailsComponent",
    props:{
      lang: Object
    },
    components: {
      
      LoaderComponent
    },
    data () {
      return {

        mainTable: "",
        id: "RequestDetailsComponent",
        properties: [],
        pureProperties: [],
        propertiesRevNumbers: [],
        colorValues: [],
        currentPackage: {},
        packages: {},
        symbolSvg: {},
        place: {},
        currentRevisionId: "",
        requestFiles: null,
        libraryTypes: [],
        listAllRevisionFiles: {},
        listAllImageTriggers: {},
        libraryType: "",
        verCounter: 0,
        value: ""
      }
    },
    computed: {
      ...mapGetters({

        globalSettings: "globalSettings"

      }),
      
      
      isEdit(){
        return this.$store.getters.isEditPropertyForm;
      },
      
      isData() {
        
        return this.properties.length > 0;
      },
      
      
      
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      },
      propertyRequestToSaving() {
        return this.$store.getters.propertyRequestToSaving;
      },
      reloadedAfterActionComplex() {
        return this.$store.getters.reloadedAfterActionComplex;
      },
      type() {
        return 
      }
    },
    created() {
      
      this.$store.dispatch("deselectAllRevisionRow");

      this.getRequestDetails();

        
        
      

      //this.loadDataForRevisions();

      this.$store.dispatch("setSaveStatus", false);

    },
    watch: {
      
      isEdit: function(){
        
      
        this.getRequestDetails();
      },
      
      
      
      
              

      requestFiles: function (newVal) {
      
        this.$store.dispatch("setSaveStatus", true);
        this.$store.commit("ADDREQUESTFILESTOSAVING", newVal);
      },
      reloadedAfterActionComplex: {
        handler: function (newValue) {

          for (let el in newValue) {

            if (newValue[el].name == this.id) {
              if (newValue[el].status == true) {

                this.getRequestDetails();

                newValue[el].status = false;

                this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
              }
            }
          }
        },
        deep: true

      },
    },
      
  methods: {
    setTypeOfElement() {


      this.$router.replace({
        query: {
          ...this.$route.query,
          type: this.properties.type
        }
      })

    },
    checkIfSaved() {

      let trig = false;
      for (let i = 0, lei = this.properties[0].length; i < lei; i++) {

        if (this.pureProperties[i].value.display != this.propertyRequestToSaving[i].value) {

          trig = true;
        }
      }

      if (trig == true) {
        this.$store.dispatch("setSaveStatus", true)
      } else {
        this.$store.dispatch("setSaveStatus", false)
      }
      },
    getRequestDetails() {
      
      let vue = this;

      const obj = {
        requestId: this.$route.query.requestId,
        type: "part"
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRequestDetails', obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              
              

              vue.properties = vue.prepareData(result.data);

              vue.setTypeOfElement();
              

              vue.buildTable();
            }
            
        })


      },
    prepareData(data) {

      let tab = [];

      let obj = {
        priority: 0,
        fieldType: "text",
        name: "Manufacturer",
        value: data.manufacturer,
        type: "manufacturer"
        
      }
      tab.push(obj);
      obj = {
        priority: 1,
        fieldType: "text",
        name: "ManufacturerPartNumber",
        value: data.manufacturerPartNumber,
        type: "manufacturerPartNumber"
      }
      tab.push(obj);
      obj = {
        priority: 2,
        fieldType: "list",
        name: "Priority",
        value: data.priority,
        type: "priority"
      }
      tab.push(obj);
      let deadLine = data.deadLine;
      if (data.deadLine == undefined) {
        deadLine = data.deadLine;
      }
      obj = {
        priority: 3,
        fieldType: "date",
        name: "Deadline",
        value: deadLine,
        type: "deadLine"
      }
      tab.push(obj);
      obj = {
        priority: 4,
        fieldType: "textarea",
        name: "Remarks",
        value: data.remarks,
        type: "remarks"
      }
      tab.push(obj);
      obj = {
        priority: 5,
        fieldType: "files",
        name: "Files",
        value: data.Files,
        type: "files"
      }
      tab.push(obj);

      return tab;
    },
   
    
    validateValues(obj) {
      
      let vue = this;

      let arr = [obj];

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateRequestValidation", arr)
        .then((result) => {

          console.log(result);

          if (result.status == "OK") {
            if (result.data.valid == false) {


              for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                vue.displayValidationRules(result.data.violatedRules[i])
              }
            } else {
              vue.resetValidationRules(obj);
            }
          }



        })


    },
    displayValidationRules(obj) {

      let id = "value__" + obj.type;
      let elem = document.getElementById(id);
      elem.classList.add("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: block");
      elemInvalidFeedback.innerHTML = obj.message;

    },
    resetValidationRules(obj) {
     
      let id = "value__" + obj.type;
      let elem = document.getElementById(id);
      
      elem.classList.remove("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: none");
      elemInvalidFeedback.innerHTML = "";
    },
    checkFormValidationAfterLoad() {


      let editParts = document.getElementsByClassName('edit-part');

      for (var i = 0; i < editParts.length; i++) {

        let temp = editParts[i].id.split("__")

        const validObj = {
          propertyId: temp[1],
          value: editParts[i].value,
        }
        this.validateValues(validObj);


      }

    },
      
    buildTable(){
      
      

      if (this.isEdit == true){

        this.$store.commit("RESETPROPERTYREQUESTTOSAVING");
        this.$store.commit("RESETREQUESTFILESTOSAVING");

        
        for (let i = 0, lei = this.properties.length; i < lei; i++){
          
          if (this.properties[i].type != "files"){
            let obj = {
              type: this.properties[i].type,
              value: this.properties[i].value,
              
            }
            if (this.properties[i].type == "deadLine" && this.properties[i].value == "0001-01-01T00:00:00") {
              obj.value = null;
            }

            this.$store.commit("ADDPROPERTYREQUESTTOSAVING", obj);
          }
          

        }

      }
      

      var tableplace = document.getElementById(this.id);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("class", "table table-striped table-bordered");
      table.setAttribute("style", "width:100%;");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      
      let vue = this;


      let cols = [
        { "data": "priority" },
        { "data": "name" },
        { "data": "value" },
        
      ]

      

      let columns = [
        
        {
          name: "Priority",
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Value,
          alignInColumn: "left",

        },

      ]

      var columnDefs = [];
      
      
      for (var i = 0, len = columns.length; i < len; i++){

        let classname = '_dt-body-'+ columns[i].alignInColumn;

        let  el = {
            targets: i,
            className: classname,
          render: function (data, type, row, meta) {
            
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

                        
            if (meta.col == 0){
              return data;
            }
            if (meta.col == 1){
              return data;
            }
            
            if (meta.col == 2) {

              if (vue.isEdit == false) {
                if (row.fieldType == "date") {
                  if (data == "0001-01-01T00:00:00") {
                    return "";
                  }
                  return Tools.longDateToShort(data, false);
                }
                if (row.fieldType == "list") {
                  if (data == "High"){
                    return "<b-badge class=\"badge badge-danger\"> " + data + " </b-badge>";
                  }
                  if (data == "Normal"){
                    return "<b-badge class=\"badge badge-blue\"> " + data + " </b-badge>";
                  }
                  if (data == "Low"){
                    return "<b-badge class=\"badge badge-success\"> " + data + " </b-badge>";
                  }
                }
                if (row.fieldType == "files") {
                  
                  let str = "<table class=\"file-table\">";
                  
                            
                  for (let i = 0, lei = data.length; i < lei; i++) {
                    str += "<tr class=\"file-tr\">"
                    str += "<td>"
                    let file = data[i];

                    let src = Tools.filenameToIcon(file.fileName);
                    str += "<a id=\"download_^_" + file.fileId + "_^_" + file.fileName + "_^_" + file.fileId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                    str += file.fileName + "</a></td><td>" + file.fileSize + "</td><td>" + Tools.longDateToShort(file.createDate) + "   <br>";
                    str += "</td>"
                    
                    str += "</tr>"
                  }
                  str += "</table>";
                  
                  return str;
                }
              }

              if (vue.isEdit == true) {
                if (row.fieldType == "text" && row.type == "manufacturer") {

                  return "<input data-type=\"" + row.type + "\"  id=\"value__" + row.type + "\" class=\"form-control edit-field\"  value=\"" + data + "\"></input><div class=\"invalid\" id=\"value__" + row.type + "__invalid\"></div>";
                }
                if (row.fieldType == "text" && row.type == "manufacturerPartNumber") {

                  return "<input data-type=\"" + row.type + "\"  id=\"value__" + row.type + "\" class=\"form-control edit-field\" value=\"" + data + "\"></input><div class=\"invalid\" id=\"value__" + row.type + "__invalid\"></div>";
                }
                
                if (row.fieldType == "date") {
                  let date = Tools.longDateToShort(data, false);
                  if (data == "0001-01-01T00:00:00") {
                    date = "";
                  } else {
                    date = Tools.longDateToShort(data, false);
                  }
                  // <input type="date" class="form-control">
                 
                  
                  return "<div class=\"custom-date-wrapper\"><input data-type=\"" + row.type + "\"  id=\"value__" + row.type + "\" type=\"date\" value=\""+date+"\" class=\"form-control edit-field field-date\"><div class=\"invalid\" id=\"value__" + row.type + "__invalid\"></div></div>"
                  
                }
                if (row.fieldType == "list") {
                  
                  
                  let str = "<select class=\"form-control edit-field type-select\"  data-type=\"" + row.type + "\"  id=\"value__" + row.type + "\">";
                            
                    const tab = ["High", "Normal", "Low"];
                    for (let j = 0, lej = tab.length; j < lej; j++){

                      let selected = "selected";
                      if (tab[j] == data) {
                        str += "<option value=\""+tab[j]+"\" "+selected+">"+tab[j]+"</option>";
                      } else {
                        str += "<option value=\""+tab[j]+"\">"+tab[j]+"</option>";
                      }
                      
                    }
                    
                    str += "</select>";
                    str += "<div class=\"invalid\" id=\"value__" + row.type + "__invalid\"></div>";
                  return str;
                  
                }
                if (row.fieldType == "textarea") {

                  return "<textarea data-type=\"" + row.type + "\"  id=\"value__" + row.type + "\" placeholder=\"Enter remarks...\" rows=\"6\" wrap=\"soft\" class=\"item-form remarks-textarea mb-1 form-control form-control-sm edit-field\">"+data+"</textarea><div class=\"invalid\" id=\"value__" + row.type + "__invalid\"></div>";
                }
                if (row.fieldType == "files") {
                  
                  let str = "<table class=\"file-table\">";
                  
                            
                  for (let i = 0, lei = data.length; i < lei; i++) {
                    str += "<tr class=\"file-tr\">"
                    str += "<td>"
                    let file = data[i];

                    let src = Tools.filenameToIcon(file.fileName);
                    str += "<a id=\"download_^_" + file.fileId + "_^_" + file.fileName + "_^_" + file.fileId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                    str += file.fileName + "</a></td><td>" + file.fileSize + "</td><td>" + Tools.longDateToShort(file.createDate) + "   <br>";
                    str += "</td>"
                    str += "<td>";
                    str += "<button class=\"btn btn-secondary btn-sm btn-" + vue.variant + " button_action_delete_file\" id=\"button_deleteFile___" + file.fileId + "\" data-revisionid=\"" + file.fileId + "\">" + vue.lang.button_DeleteFile + "</button>"
                    str += "</td>";
                    str += "</tr>"
                  }
                  str += "</table>";
                  
                  return str;
                }
              }
              
              return data;
            }
              


            return data;
          }
        }

        columnDefs.push(el);
        
        

        var th = document.createElement("th");
        
        tr.appendChild(th);
        
        var br = document.createElement("br");
        var tx = document.createTextNode(columns[i].name);
        th.appendChild(br);
        th.appendChild(tx);

        
      }
      
      

      var json = {};
      json.paging = false;
      json.sort = false;
      json.info = false;
      json.dom = 'f<t>';
      json.data= this.properties;
      json.myColumnFormats = columns;
      json.select = false;
      json.columns = cols;
      json.columnDefs = columnDefs;
      json.order = [0, "asc"];
      json.initComplete = function () {

        //vue.checkFormValidationAfterLoad();
        //vue.moveDatepicker();
      }

      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          
      }

      

      this.mainTable = $('#t_'+this.id).DataTable(json);


      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );
      // this.mainTable.column( 1 ).visible( false );

      //search input change view
      var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }

      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

      

      let editParts = document.getElementsByClassName('edit-field');

        for (var i = 0; i < editParts.length; i++) {
          editParts[i].addEventListener('input', function (e){

            //let temp = this.id.split("__");
            
            let type = this.dataset.type;
            
            let obj = {
              value: this.value,
              type: type,
              
            }
            const validObj = {
              type: type,
              value: this.value,
            }
            
            vue.validateValues(validObj);

            vue.$store.commit("ADDPROPERTYREQUESTTOSAVING", obj);

            vue.checkIfSaved();
          })
      }

      for (var i = 0; i < editParts.length; i++) {
        editParts[i].addEventListener('focus', function (e) {

          


          
        })
      }

      
      let download_buttons = document.getElementsByClassName('button-action-download');

      for (let i = 0, lei = download_buttons.length; i < lei; i++) {
        download_buttons[i].addEventListener('click', function (e){
          let id = this.id;
          let temp = id.split("_^_");
          
          
          const obj = {
            fileId: temp[1],
                      
          }


          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_downloadFile", obj)
          .then((result) =>{


              console.log(result)
              let fileName = temp[2];
  
              var a = document.createElement("a");
              a.href = URL.createObjectURL(result);
              a.download = fileName;
              
              document.body.appendChild(a);
              
              a.click();
              document.body.removeChild(a);
          })
        })
      }  

      let buttons_action_deleteFile = document.getElementsByClassName('button_action_delete_file');


      for (var i = 0; i < buttons_action_deleteFile.length; i++) {
        buttons_action_deleteFile[i].addEventListener('click', function (){

                    
          let temp = this.id.split("___")
          let fileId = temp[1];
          
         
          

          let deleteFile = function(){
                                
            let obj = {
              fileId: fileId,
              requestId: vue.$route.query.requestId
            }
            

            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteRequestFile", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){
                if (result.data != null){


                  const obj = {
                    text: vue.lang.alert_success_DeleteFile,
                    time: 10,
                    type: "success"
                  }

                  vue.$store.dispatch("displayFooterAlert", obj);

                  
                  const reloadObj = {
                      status: true,
                      name: "RequestDetailsComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                }else{
                  

                  const obj = {
                    text: vue.lang.alert_error_DeleteFile + ".",
                    time: 15,
                    type: "danger"
                  }

                  vue.$store.dispatch("displayFooterAlert", obj);

                }
              }else{
                const obj = {
                  text: vue.lang.alert_error_DeleteFile + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

              }
              



            })
          }
                        

          

          var obj = {
            title: vue.lang.alert_Title_deleteFile,
            text: vue.lang.alert_deleteFile,
            type: "sure",
            buttons: 2,
            size: "sm",
            funcNo: "",
            funcYes: deleteFile

          }
          vue.$store.dispatch("showAlert", obj);



        }, false);
      }

      
      
    },

  }

}
</script>
<style lang="scss">


  @import "./../../scss/_custom.scss";

  .RequestDetailsComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }

    table td {
      padding: 0.2rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm {
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $orange;
      //font-weight: 700;
    }
    .blue{
      color: $blue;
      font-weight: 700;
    }
    .yellow{
      color: $yellow;
      font-weight: 700;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $lightgreen;
      //font-weight: 700;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26px;
    }
    td{
      word-break: break-all;
    }
    input-group{
      min-width: 200px;
    }
      
    
    .required{
      float: right;
      margin: 4px;
    }
    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    .badge{
      margin-right: 3px;
    }
    .button-action-download{
      margin: 2px;
      padding: 0rem 0.5rem;
      height: 22px;
    }
    .button_action_delete_file{
      margin-bottom: 2px;
      margin-top: 2px;
      padding-top: 1px;
      padding-bottom: 1px;
      height: 20px;
      
    }
    .file-table{
      width: 100%;
      border-style: hidden;
      //border-color: #666;
    }
    .file-tr{
      
      border-style: hidden;
      //border-color: #666;
    }
    
    input::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
    .edit-part{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .name-column{
      white-space: break-spaces;
    }
    .nodisplay{
      display: none !important;
    }
    
    .loader{
      margin: 10px;
    }
    .remarks-textarea{
      height: 100px;
    }

    
    .field-date {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: textfield;
      position: relative;
      padding-right: 30px;
      
    }

    .field-date::-webkit-calendar-picker-indicator {
      opacity: 1; 
      position: absolute;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      //filter: invert(1) sepia(2) saturate(5) hue-rotate(190deg); /* zmiana koloru */
    }

    
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/RequestDetailsComponent.vue